import React, { useRef, useState } from 'react';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

  .qc-root {
    font-family: 'Inter', sans-serif;
    background-color: #0f172a;
    color: #f8fafc;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    padding: 2rem 0;
  }

  .qc-container {
    width: 100%;
    max-width: 1000px;
    padding: 2rem;
    margin: 0 2rem;
    background: rgba(30, 41, 59, 0.7);
    backdrop-filter: blur(12px);
    border: 1px solid #334155;
    border-radius: 16px;
    box-shadow: 0 25px 50px -12px rgba(0,0,0,0.5);
    align-self: flex-start;
  }

  .qc-header {
    text-align: center;
    margin-bottom: 2rem;
  }

  .qc-header h1 {
    margin: 0 0 0.5rem 0;
    font-size: 2.2rem;
    background: linear-gradient(135deg, #60a5fa, #a78bfa);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  .qc-header p {
    color: #94a3b8;
    margin: 0 auto;
    max-width: 600px;
    font-size: 1rem;
    line-height: 1.5;
  }

  .qc-input-group {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    margin-bottom: 1.5rem;
  }

  .qc-label {
    font-weight: 600;
    font-size: 0.9rem;
    color: #94a3b8;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  .qc-textarea {
    width: 100%;
    height: 350px;
    background: rgba(15, 23, 42, 0.5);
    color: #f8fafc;
    border: 1px solid #334155;
    border-radius: 12px;
    padding: 1rem;
    font-family: 'JetBrains Mono', 'Fira Code', monospace;
    font-size: 0.9rem;
    resize: vertical;
    transition: border-color 0.2s;
    box-sizing: border-box;
  }

  .qc-textarea:focus {
    outline: none;
    border-color: #3b82f6;
    background: rgba(15, 23, 42, 0.8);
  }

  .qc-options-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1.5rem;
    background: rgba(15, 23, 42, 0.3);
    padding: 1.5rem;
    border-radius: 12px;
    border: 1px solid #334155;
    margin-bottom: 1rem;
  }

  .qc-option-item {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .qc-option-item input[type="text"] {
    background: #0f172a;
    border: 1px solid #334155;
    border-radius: 6px;
    padding: 0.5rem;
    color: #f8fafc;
    width: 100%;
    box-sizing: border-box;
    font-family: 'Inter', sans-serif;
  }

  .qc-checkbox-item {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    cursor: pointer;
    user-select: none;
    margin-top: 1.5rem;
  }

  .qc-checkbox-item input {
    width: 18px;
    height: 18px;
    cursor: pointer;
  }

  .qc-actions {
    display: flex;
    gap: 1rem;
    margin-top: 1rem;
  }

  .qc-btn {
    flex: 1;
    padding: 1rem;
    border: none;
    border-radius: 8px;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    font-family: 'Inter', sans-serif;
  }

  .qc-btn-primary {
    background: #3b82f6;
    color: white;
  }

  .qc-btn-primary:hover {
    background: #2563eb;
    transform: translateY(-2px);
  }

  .qc-btn-secondary {
    background: transparent;
    border: 1px solid #334155;
    color: #f8fafc;
  }

  .qc-btn-secondary:hover {
    background: rgba(255,255,255,0.05);
  }

  .qc-alert {
    padding: 1rem;
    border-radius: 8px;
    margin-top: 1rem;
    font-size: 0.9rem;
    line-height: 1.4;
  }

  .qc-alert-success {
    background: rgba(16,185,129,0.1);
    color: #10b981;
    border: 1px solid rgba(16,185,129,0.2);
  }

  .qc-alert-danger {
    background: rgba(239,68,68,0.1);
    color: #ef4444;
    border: 1px solid rgba(239,68,68,0.2);
  }

  .qc-syntax-help {
    margin-top: 2rem;
    background: rgba(15, 23, 42, 0.2);
    border: 1px solid #334155;
    border-radius: 12px;
    padding: 1.5rem;
  }

  .qc-syntax-help h2 {
    font-size: 1.1rem;
    margin-top: 0;
    color: #3b82f6;
  }

  .qc-syntax-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 1.5rem;
    margin-top: 1rem;
  }

  .qc-syntax-card {
    background: rgba(0,0,0,0.2);
    padding: 1rem;
    border-radius: 8px;
    border-left: 3px solid #3b82f6;
  }

  .qc-syntax-card h3 {
    font-size: 0.9rem;
    margin: 0 0 0.5rem 0;
    color: #f8fafc;
  }

  .qc-syntax-card code {
    font-size: 0.8rem;
    color: #94a3b8;
    white-space: pre-wrap;
  }

  .qc-footer {
    margin-top: 3rem;
    text-align: center;
    color: #94a3b8;
    font-size: 0.8rem;
    border-top: 1px solid #334155;
    padding-top: 1.5rem;
  }

  @media (max-width: 640px) {
    .qc-container {
      margin: 0;
      border-radius: 0;
      padding: 1.5rem;
    }
  }
`;

// ─── Converter Logic (ported from Vanilla JS) ──────────────────────────────

function createConverter() {
  return {
    removeEnum: false,
    defaultPoint: 1,
    defaultDifficulty: 1,
    txtInputString: '',
    inputTextArray: [],
    arrayLocation: 0,
    activeArrayLine: '',
    tempQuestion: '',
    fullQuestion: '',
    correctAnsCnt: 0,
    partialAnsCnt: 0,
    questionPointValue: 1,
    questionDifficulty: 1,
    questionImage: '',
    questionType: '',
    nonMultiQuestion: false,
    ansTrue: 0,
    ansFalse: 0,
    answerArray: [],
    matchArray: [],
    choiceArray: [],
    orderArray: [],
    hintText: '',
    feedbackText: '',
    answerKeyText: '',
    initialText: '',
    trueFeedback: '',
    falseFeedback: '',
    outputCSV: [],
    outputData: '',
    questionOffset: 0,
    partCorrectArray: [0, 20, 25, 33.33, 40, 50, 60, 66.67, 75, 80, 100],
    errorMessage: null,
  };
}

function convertQuestions(inputText, defaultPoint, defaultDifficulty, removeEnum) {
  const c = createConverter();
  c.removeEnum = removeEnum;
  c.defaultPoint = defaultPoint || 1;
  c.defaultDifficulty = defaultDifficulty || 1;
  c.questionPointValue = c.defaultPoint;
  c.questionDifficulty = c.defaultDifficulty;

  let txt = inputText;
  if (!txt || txt.trim() === '') return { error: 'Please add some questions to convert.' };

  txt = txt.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
  while (txt.charAt(0) === '\n') txt = txt.substring(1);
  let len = txt.length;
  while (txt.charAt(len - 1) === '\n' && txt.charAt(len - 2) === '\n') {
    txt = txt.slice(0, len - 1);
    len = txt.length;
  }

  c.txtInputString = txt;
  c.inputTextArray = txt.split('\n');
  c.arrayLocation = 0;

  const result = evalQuestion(c);
  if (result && result.error) return result;
  return { data: c.outputData };
}

function evalQuestion(c) {
  c.questionType = '';
  c.nonMultiQuestion = false;
  c.correctAnsCnt = 0;
  c.partialAnsCnt = 0;
  c.questionImage = '';
  c.hintText = '';
  c.feedbackText = '';
  c.answerKeyText = '';
  c.initialText = '';
  c.trueFeedback = '';
  c.falseFeedback = '';
  c.answerArray = [];
  c.matchArray = [];
  c.choiceArray = [];
  c.orderArray = [];
  c.questionPointValue = c.defaultPoint;
  c.questionDifficulty = c.defaultDifficulty;

  if (c.arrayLocation >= c.inputTextArray.length) { allDone(c); return; }
  if (c.inputTextArray[c.arrayLocation].length < 2) {
    c.arrayLocation++;
    if (c.arrayLocation < c.inputTextArray.length) return evalQuestion(c);
    else { allDone(c); return; }
  }

  c.activeArrayLine = c.inputTextArray[c.arrayLocation];

  if (/^SA/i.test(c.activeArrayLine)) { c.questionType = 'SA'; c.nonMultiQuestion = true; c.questionOffset = 3; }
  else if (/^text/i.test(c.activeArrayLine)) { c.questionType = 'TXT'; c.nonMultiQuestion = true; c.questionOffset = 5; }
  else if (/^image/i.test(c.activeArrayLine)) { c.questionType = 'IMG'; c.nonMultiQuestion = true; c.questionOffset = 6; }
  else if (/^match/i.test(c.activeArrayLine)) { c.questionType = 'M'; c.nonMultiQuestion = true; c.questionOffset = 6; }
  else if (/^order/i.test(c.activeArrayLine)) { c.questionType = 'O'; c.nonMultiQuestion = true; c.questionOffset = 6; }
  else { c.questionOffset = 0; }

  getQuestionText(c);
}

function getQuestionText(c) {
  const line = c.activeArrayLine;
  const period = line.indexOf('.');
  const paren = line.indexOf(')');
  const sp = line.indexOf(' ', c.questionOffset);
  const separate = (period === -1 || (paren !== -1 && paren < period)) ? paren : period;

  if (separate !== -1 && separate < (5 + c.questionOffset) && sp !== -1 && separate === sp - 1) {
    c.tempQuestion = line.substring(sp + 1);
  } else {
    c.tempQuestion = line.substring(c.questionOffset);
  }
  c.fullQuestion = line;
  c.arrayLocation++;
  evalAnswers(c);
}

function evalAnswers(c) {
  if (c.arrayLocation >= c.inputTextArray.length) { addQuestion(c); return; }

  const line = c.inputTextArray[c.arrayLocation].trim();
  c.activeArrayLine = line;

  if (line.length === 0) { addQuestion(c); return; }

  if (line.charAt(0) === '=') { c.questionPointValue = parseInt(line.substring(1)); c.arrayLocation++; evalAnswers(c); }
  else if (line.charAt(0) === '!') { c.questionDifficulty = parseInt(line.substring(1)); c.arrayLocation++; evalAnswers(c); }
  else if (line.charAt(0) === '?') { c.hintText = line.substring(1); c.arrayLocation++; evalAnswers(c); }
  else if (line.charAt(0) === '@' && line.charAt(1) !== '@') { c.feedbackText = line.substring(1); c.arrayLocation++; evalAnswers(c); }
  else if (line.charAt(0) === '&') { c.answerKeyText = line.substring(1); c.arrayLocation++; evalAnswers(c); }
  else if (line.charAt(0) === '|') { c.initialText = line.substring(1); c.arrayLocation++; evalAnswers(c); }
  else if (/^img=/i.test(line)) { c.questionImage = line.substring(4); c.arrayLocation++; evalAnswers(c); }
  else if (c.questionType === 'SA') { c.answerArray.push(line); c.arrayLocation++; evalAnswers(c); }
  else if (c.questionType === 'M') {
    let l = line;
    if (c.removeEnum) l = l.replace(/^\(.\)\s*|^.\.\s*|^.\)\s*/, '');
    const parts = l.split('/');
    if (parts.length > 1) { c.choiceArray.push(parts[1].trim()); c.matchArray.push(parts[0].trim()); }
    else { c.choiceArray.push(parts[0].trim()); c.matchArray.push(''); }
    c.answerArray.push(l);
    c.arrayLocation++; evalAnswers(c);
  }
  else if (c.questionType === 'O') {
    let l = line;
    if (c.removeEnum) l = l.replace(/^.\.\s*|^.\)\s*/, '');
    c.orderArray.push(l); c.answerArray.push(l);
    c.arrayLocation++; evalAnswers(c);
  }
  else if (/^(True|T|Verdadeiro)$/i.test(line)) {
    c.questionType = 'TF'; c.nonMultiQuestion = true; c.ansTrue = 100; c.ansFalse = 0;
    c.arrayLocation++; evalAnswers(c);
  }
  else if (/^(False|F|Falso)$/i.test(line)) {
    c.questionType = 'TF'; c.nonMultiQuestion = true; c.ansTrue = 0; c.ansFalse = 100;
    c.arrayLocation++; evalAnswers(c);
  }
  else if (line.startsWith('T@@')) { c.trueFeedback = line.substring(3); c.arrayLocation++; evalAnswers(c); }
  else if (line.startsWith('F@@')) { c.falseFeedback = line.substring(3); c.arrayLocation++; evalAnswers(c); }
  else if (line.charAt(0) === '*') { ++c.correctAnsCnt; c.answerArray.push(line); c.arrayLocation++; evalAnswers(c); }
  else if (line.charAt(0) === '+') { ++c.partialAnsCnt; c.answerArray.push(line); c.arrayLocation++; evalAnswers(c); }
  else { c.answerArray.push(line); c.arrayLocation++; evalAnswers(c); }
}

function addQuestion(c) {
  if (c.answerArray.length < 1 && !['TF', 'TXT', 'IMG', 'SA', 'M'].includes(c.questionType)) {
    c.questionType = 'WR'; c.nonMultiQuestion = true;
  }
  if (c.correctAnsCnt >= 2) c.questionType = 'MS';
  if (c.correctAnsCnt === 1) c.questionType = 'MC';

  if (!c.nonMultiQuestion && c.correctAnsCnt === 0) {
    c.errorMessage = 'A correct answer is not identified for: ' + c.fullQuestion;
    return;
  }

  const q = (txt) => '"' + txt.replace(/"/g, '""') + '"';

  c.outputCSV.push(['NewQuestion', c.questionType, '', '', '']);
  c.outputCSV.push(['Title', '', '', '', '']);
  if (c.questionType !== 'IMG') c.outputCSV.push(['QuestionText', q(c.tempQuestion), '', '', '']);
  if (!['TXT', 'IMG'].includes(c.questionType)) {
    c.outputCSV.push(['Points', c.questionPointValue, '', '', '']);
    c.outputCSV.push(['Difficulty', c.questionDifficulty, '', '', '']);
  }
  if (c.questionImage) c.outputCSV.push(['Image', c.questionImage, '', '', '']);

  if (c.questionType === 'TF') {
    c.outputCSV.push(['TRUE', c.ansTrue, q(c.trueFeedback), '', '']);
    c.outputCSV.push(['FALSE', c.ansFalse, q(c.falseFeedback), '', '']);
  } else if (['MC', 'MS'].includes(c.questionType)) {
    for (let i = 0; i < c.answerArray.length; i++) {
      let val = 0, offset = 0;
      if (c.answerArray[i].charAt(0) === '*') { val = (c.questionType === 'MC' ? 100 : 1); offset = 1; }
      let txt = c.answerArray[i].substring(offset);
      if (c.removeEnum) txt = txt.replace(/^.\.\s*|^.\)\s*/, '');
      let feedback = '';
      if (i + 1 < c.answerArray.length && c.answerArray[i + 1].startsWith('@@')) {
        feedback = c.answerArray[i + 1].substring(2); i++;
      }
      c.outputCSV.push(['Option', val, q(txt), '', q(feedback)]);
    }
  } else if (c.questionType === 'M') {
    c.outputCSV.push(['Scoring', 'EquallyWeighted', '', '', '']);
    for (let i = 0; i < c.matchArray.length; i++) {
      c.outputCSV.push(['Choice', i + 1, q(c.choiceArray[i]), '', '']);
      if (c.matchArray[i]) c.outputCSV.push(['Match', i + 1, q(c.matchArray[i]), '', '']);
    }
  } else if (c.questionType === 'O') {
    c.outputCSV.push(['Scoring', 'RightMinusWrong', '', '', '']);
    for (let i = 0; i < c.orderArray.length; i++) {
      let feedback = '';
      if (i + 1 < c.orderArray.length && c.orderArray[i + 1].startsWith('@@')) {
        feedback = c.orderArray[i + 1].substring(2); i++;
      }
      c.outputCSV.push(['Item', q(c.orderArray[i]), 'NOT HTML', q(feedback)]);
    }
  } else if (c.questionType === 'SA') {
    c.outputCSV.push(['InputBox', '3', '40', '', '']);
    for (let i = 0; i < c.answerArray.length; i++) {
      let weight = 100;
      if (i + 1 < c.answerArray.length && c.answerArray[i + 1].startsWith('%')) {
        weight = parseInt(c.answerArray[i + 1].substring(1)); i++;
      }
      c.outputCSV.push(['Answer', weight, q(c.answerArray[i]), '', '']);
    }
  }

  if (!['TXT', 'IMG'].includes(c.questionType)) {
    if (c.hintText) c.outputCSV.push(['Hint', q(c.hintText), '', '', '']);
    if (c.feedbackText) c.outputCSV.push(['Feedback', q(c.feedbackText), '', '', '']);
  }

  c.arrayLocation++;
  evalQuestion(c);
}

function allDone(c) {
  c.outputData = c.outputCSV.map(row => row.join(',')).join('\n');
}

function saveAsCSV(filename, data) {
  const blob = new Blob([data], { type: 'text/csv' });
  const elem = document.createElement('a');
  elem.href = URL.createObjectURL(blob);
  elem.download = filename;
  document.body.appendChild(elem);
  elem.click();
  document.body.removeChild(elem);
}

// ─── React Component ────────────────────────────────────────────────────────

export default function QuizConverter() {
  const textRef = useRef(null);
  const [defaultPoint, setDefaultPoint] = useState('');
  const [defaultDifficulty, setDefaultDifficulty] = useState('');
  const [removeEnum, setRemoveEnum] = useState(false);
  const [alert, setAlert] = useState(null); // { type: 'success'|'danger', message: string }

  const handleConvert = () => {
    setAlert(null);
    const input = textRef.current?.value || '';
    const point = defaultPoint ? parseInt(defaultPoint) : 1;
    const difficulty = defaultDifficulty ? parseInt(defaultDifficulty) : 1;

    const result = convertQuestions(input, point, difficulty, removeEnum);

    if (result.error) {
      setAlert({ type: 'danger', message: result.error });
    } else {
      setAlert({ type: 'success', message: 'Success! Your questions have been converted. The download should start automatically.' });
      saveAsCSV('quiz.csv', result.data);
    }
  };

  const handleClear = () => {
    if (textRef.current) textRef.current.value = '';
    setAlert(null);
  };

  return (
    <>
      <style>{styles}</style>
      <div className="qc-root">
        <div className="qc-container">
          <header className="qc-header">
            <h1>Quiz Question Converter</h1>
            <p>Convert your questions to Brightspace Question Library CSV format instantly. Designed for high-performance pedagogical management.</p>
          </header>

          <div className="qc-input-group">
            <label className="qc-label" htmlFor="qc-textInput">Questions Input</label>
            <textarea
              id="qc-textInput"
              className="qc-textarea"
              ref={textRef}
              placeholder="Paste your questions here..."
            />
          </div>

          <div className="qc-options-grid">
            <div className="qc-option-item">
              <label className="qc-label" htmlFor="qc-defaultPoint">Default Points</label>
              <input
                type="text"
                id="qc-defaultPoint"
                placeholder="1"
                value={defaultPoint}
                onChange={e => setDefaultPoint(e.target.value)}
              />
            </div>
            <div className="qc-option-item">
              <label className="qc-label" htmlFor="qc-defaultDifficulty">Default Difficulty</label>
              <input
                type="text"
                id="qc-defaultDifficulty"
                placeholder="1"
                value={defaultDifficulty}
                onChange={e => setDefaultDifficulty(e.target.value)}
              />
            </div>
            <label className="qc-checkbox-item" htmlFor="qc-removeEnum">
              <input
                type="checkbox"
                id="qc-removeEnum"
                checked={removeEnum}
                onChange={e => setRemoveEnum(e.target.checked)}
              />
              <span style={{ fontWeight: 600, fontSize: '0.9rem', color: '#94a3b8' }}>Remove enumeration from answers</span>
            </label>
          </div>

          <div className="qc-actions">
            <button className="qc-btn qc-btn-primary" id="qc-btnConvert" onClick={handleConvert}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                <polyline points="7 10 12 15 17 10"/>
                <line x1="12" y1="15" x2="12" y2="3"/>
              </svg>
              Convert &amp; Download CSV
            </button>
            <button className="qc-btn qc-btn-secondary" id="qc-btnClear" onClick={handleClear}>
              Clear Text
            </button>
          </div>

          {alert && (
            <div className={`qc-alert qc-alert-${alert.type}`}>
              {alert.message}
            </div>
          )}

          <div className="qc-syntax-help">
            <h2>Quick Syntax Guide</h2>
            <div className="qc-syntax-grid">
              <div className="qc-syntax-card">
                <h3>Multiple Choice (MC)</h3>
                <code>{`1. Question text\n*Correct answer\nIncorrect answer\nIncorrect answer`}</code>
              </div>
              <div className="qc-syntax-card">
                <h3>True / False (TF)</h3>
                <code>{`2. Statement text\nTrue\nFalse\n*True`}</code>
              </div>
              <div className="qc-syntax-card">
                <h3>Short Answer (SA)</h3>
                <code>{`SA 3. What is the capital of France?\nParis`}</code>
              </div>
              <div className="qc-syntax-card">
                <h3>Meta Tags (Global)</h3>
                <code>{`=10 (Points for this question)\n!3 (Difficulty 1-5)\n?Hint text\n@Overall feedback`}</code>
              </div>
            </div>
          </div>

          <footer className="qc-footer">
            &copy; 2026 robertorocha.tech · Developed for Experience Accelerator (FGV EAESP)
          </footer>
        </div>
      </div>
    </>
  );
}
